import React, { useEffect, useState } from 'react'
import { Btn, CustomInputTextArea, CustomModal, InputNumeroDecimal } from '../../../../components'
import {
  postCancelarCiot,
  postEncerrarCiot,
} from '../../../../services/api/https/deliveries/ciot.http'
import { CIOT_LOTACAO, estiloAvisoCiot, estiloDicaCiot, rotuloCiot } from './ciot.util'

const MOTIVO_MINIMO = 10
const MOTIVO_MAXIMO = 500

export default function ModalAcaoCiot({ visible, acao, ciot, onClose, onConcluido, onError }) {
  const [peso, setPeso] = useState(null)
  const [motivo, setMotivo] = useState('')
  const [enviando, setEnviando] = useState(false)

  useEffect(() => {
    if (!visible || !ciot) return
    setPeso(ciot.peso_carga || null)
    setMotivo('')
  }, [visible, ciot])

  if (!ciot) return null

  const lotacao = Number(ciot.tipo_operacao) === CIOT_LOTACAO
  const declaradoNaAntt = ciot.status === 'declarado'

  const onBtnConfirmarClicked = async () => {
    if (acao === 'cancelar') {
      const texto = motivo.trim()
      if (texto.length < MOTIVO_MINIMO || texto.length > MOTIVO_MAXIMO) {
        onError(`O motivo deve ter entre ${MOTIVO_MINIMO} e ${MOTIVO_MAXIMO} caracteres`)
        return
      }
    } else if (lotacao && !(Number(peso) > 0)) {
      onError('Informe o peso da carga para encerrar o CIOT de carga lotação')
      return
    }

    setEnviando(true)
    try {
      const atualizado =
        acao === 'cancelar'
          ? await postCancelarCiot(ciot.id, motivo.trim())
          : await postEncerrarCiot(ciot.id, lotacao ? peso : null)
      onConcluido(
        atualizado,
        acao === 'cancelar'
          ? `CIOT ${rotuloCiot(atualizado)} cancelado`
          : `CIOT ${rotuloCiot(atualizado)} encerrado na ANTT`,
      )
    } catch (error) {
      onError(error)
    } finally {
      setEnviando(false)
    }
  }

  return (
    <CustomModal
      isVisible={visible}
      header={acao === 'cancelar' ? 'Cancelar CIOT' : 'Encerrar CIOT'}
      style={{ width: '90vw', maxWidth: 550 }}
      onClose={onClose}
    >
      <div className="p-grid">
        <div className="p-col-12" style={{ fontSize: '0.9rem' }}>
          CIOT <strong>{rotuloCiot(ciot)}</strong> ({lotacao ? 'carga lotação' : 'carga fracionada'}
          )
        </div>
        {acao === 'cancelar' ? (
          <>
            <div className="p-col-12">
              <div style={estiloAvisoCiot}>
                {declaradoNaAntt
                  ? 'O cancelamento é enviado à ANTT e não pode ser desfeito. O MDFe que usa este CIOT não muda: cancele ou encerre o MDFe à parte.'
                  : 'Este CIOT não foi declarado na ANTT: o número só é inutilizado no sistema.'}
              </div>
            </div>
            <div className="p-col-12">
              <CustomInputTextArea
                label={`Motivo (${MOTIVO_MINIMO} a ${MOTIVO_MAXIMO} caracteres):*`}
                marginTop={5}
                rows={3}
                value={motivo}
                onChange={value => setMotivo(value.slice(0, MOTIVO_MAXIMO))}
              />
            </div>
          </>
        ) : (
          <>
            <div className="p-col-12" style={estiloDicaCiot}>
              Encerre ao fim da viagem. Depois de encerrado, o CIOT não pode ser cancelado nem
              retificado.
            </div>
            {lotacao && (
              <div className="p-col-6">
                <InputNumeroDecimal
                  label="Peso da carga entregue (kg):*"
                  marginTop={5}
                  value={peso}
                  onChange={setPeso}
                />
              </div>
            )}
          </>
        )}
        <div
          className="p-col-12"
          style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}
        >
          <Btn backgroundColor="#999999" onClick={onClose}>
            Voltar
          </Btn>
          <Btn isLoading={enviando} onClick={onBtnConfirmarClicked}>
            {acao === 'cancelar' ? 'Cancelar CIOT' : 'Encerrar CIOT'}
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}
